import { Expose } from 'class-transformer';

import { SortDirection } from '@angular/material/sort';

import { ExposeRawData, Default } from '@lib/common/decorators';
import { IAdvancedBadgeOptions } from '@lib/geo/google/map';
import { COLORS } from '@lib/ui/theme';

import { FsFields } from './field';
import { ISnLayerIconLabel } from './layer-icon-label';
import { ISnLayerRenderer, ISnLayerLink } from './layer-renderer';

export class SnLayerMeta {
  @Expose()
  public readonly restricted?: boolean;

  @ExposeRawData()
  public readonly renderer?: ISnLayerRenderer;

  @Expose()
  public readonly fields?: FsFields;

  @Expose()
  public readonly fontSet?: string;

  @Expose()
  public readonly mouPdfUrl?: string;

  @Expose()
  public readonly iconSize?: string;

  @Expose()
  public readonly canRequestMedia?: boolean;

  @Expose()
  public readonly allowHistory?: boolean;

  @Expose()
  public readonly officerInternalIdField?: string;

  @Expose()
  public readonly allowHeatmap?: boolean;

  @Expose()
  public readonly historicalLayer?: string;

  @Expose()
  public readonly search: any;

  @Expose()
  public readonly idleTimeout: number;

  @Expose()
  public readonly isDroneSense: boolean;

  @Expose()
  public readonly scale?: number = 1;

  @Expose()
  @Default(1)
  public readonly fillOpacity?: number;

  @Expose()
  public readonly fillColor?: string;

  @Expose()
  @Default(1)
  public readonly strokeOpacity?: number;

  @Expose()
  @Default(1)
  public readonly strokeWeight?: number;

  @Expose()
  public readonly strokeColor?: string;

  @Expose()
  public readonly hoverStrokeWeight?: number;

  @Expose()
  public readonly label?: string;

  @Expose()
  public readonly labelField?: string;

  @Expose()
  public readonly imageUrl?: string;

  @Expose()
  @Default(true)
  public readonly showLabel?: boolean;

  @ExposeRawData()
  public readonly iconLabel?: ISnLayerIconLabel;

  @ExposeRawData()
  public cadFilters?: any;

  @ExposeRawData()
  public readonly link?: ISnLayerLink;

  @ExposeRawData()
  public readonly permissions?: { subject: string; action: string }[];

  @Expose()
  @Default(10000)
  public readonly zIndex: number;

  @Expose()
  @Default(false)
  public readonly hideLabelMarkers: boolean;

  @ExposeRawData()
  public readonly cadPriorityMap?: any;

  @Expose()
  public ddp?: {
    radius?: number;
    callTypes?: string[];
    officerInternalIdCadField?: string;
    officerInternalIdDescription?: string;
  };

  @Expose()
  public readonly iconUnicode?: string;

  @Expose()
  @Default('#fff')
  public readonly iconColor?: string;

  @Expose()
  @Default(1)
  public readonly iconFillOpacity?: number;

  @Expose()
  @Default(1)
  public readonly iconStrokeWeight?: number;

  @Expose()
  @Default(1)
  public readonly iconStrokeOpacity?: number;

  @Expose()
  @Default(16)
  public readonly iconScale?: number;

  @Expose()
  @Default('18px')
  public readonly iconFontSize?: string;

  @Expose()
  @Default(COLORS['grey-400'])
  public readonly iconStrokeColor?: string;

  @Expose()
  @Default(COLORS['base-800'])
  public readonly iconFillColor?: string;

  @Expose()
  public readonly isAxonLayer?: boolean;

  @Expose()
  public readonly isCoreMobile?: boolean;

  @Expose()
  public readonly badgePosition?: IAdvancedBadgeOptions;

  @Expose()
  public readonly showAxonOfficerList?: boolean;

  @Expose()
  public readonly queryFilters?: any;

  @Expose()
  public readonly queryInterval?: number;

  @Expose()
  public readonly isPanorama?: boolean;

  @Expose()
  public readonly disableMouseOver?: boolean;

  @Expose()
  public readonly enableWebGl?: boolean;

  @Expose()
  public readonly objectIdFieldName?: string;

  @Expose()
  public readonly investigateColor?: string;

  @Expose()
  public readonly defaultSortColumn?: string;

  @Expose()
  public readonly defaultSortDirection?: SortDirection;

  @Expose()
  public readonly minimumZoomLevel?: number;

  @Expose()
  public readonly isSkydio?: boolean;

  @Expose()
  public readonly isMark43?: boolean;

  @Expose()
  public readonly hideLayer?: boolean;

  @Expose()
  public listen: any;

  [name: string]: any;

  public getFieldNames(): string[] {
    const fields = this.fields || [];
    return fields.map((f) => {
      if (typeof f === 'string') {
        return f;
      }
      return f.name;
    });
  }
}
